import type { FilesApiDatasource } from '../datasources/files-api.datasource';
import type {
  FilesSummary,
  Paginated,
  StoredFile,
  StoredFileDetail,
  StoredFileFilters,
} from '../../domain/entities/stored-file.entity';

export class FilesRepositoryImpl {
  private api: FilesApiDatasource;

  constructor(api: FilesApiDatasource) {
    this.api = api;
  }

  list(input: {
    page: number;
    perPage: number;
    filters: StoredFileFilters;
  }): Promise<Paginated<StoredFile>> {
    return this.api.list(input);
  }

  summary(filters: StoredFileFilters): Promise<FilesSummary> {
    return this.api.summary(filters);
  }

  get(fileId: string): Promise<StoredFileDetail> {
    return this.api.get(fileId);
  }

  viewUrl(fileId: string): Promise<string> {
    return this.api.viewUrl(fileId);
  }

  forceDelete(fileId: string, reason: string): Promise<StoredFileDetail> {
    return this.api.forceDelete(fileId, reason);
  }

  setLegalHold(
    fileId: string,
    input: { legalHold: boolean; reason?: string },
  ): Promise<StoredFileDetail> {
    return this.api.setLegalHold(fileId, input);
  }
}
